export default __webpack_public_path__ + "static/media/notification-bell.375947e7.svg";